import { Command } from 'commander'
import { createClient } from '../../../client.js'
import { handleError } from '../../../lib/errors.js'
import {
  isQuiet,
  printQuiet,
  printJson,
  printSuccess,
  printKeyValue,
} from '../../../output.js'

export const servicesCreateStreamsCommand = new Command(`streams`)
  .usage(`--environment <id> --name <name>`)
  .description(`Create a durable streams service`)
  .requiredOption(`--environment <id>`, `Environment ID`)
  .requiredOption(`--name <name>`, `Service name`)
  .action(async (opts) => {
    const json =
      servicesCreateStreamsCommand.parent?.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.services.streams.create({
        environmentId: opts.environment,
        name: opts.name,
      })

      if (isQuiet()) {
        printQuiet(result.serviceId)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printSuccess(`Service created successfully.\n`)
        printKeyValue([
          [`ID:`, result.serviceId],
          [`Name:`, result.name],
          [`Base URL:`, result.baseUrl],
          [`Secret:`, result.secret],
        ])
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
